import * as React from "react";

const SvgRainThunderSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunderSun_svg__a">
        <path d="m299.226 529.637-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunderSun_svg__b">
        <path d="M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunderSun_svg__c">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunderSun_svg__d">
        <path d="M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunderSun_svg__e">
        <path d="m895.908 219.964-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunderSun_svg__f">
        <path d="m909.52 219.964-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="RainThunderSun_svg__g">
        <path d="m924.132 219.964-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#RainThunderSun_svg__a)"
      style={{
        fill: "#fec125",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -352.071 764.08)"
    >
      <g
        style={{
          fill: "#fec125",
          fillOpacity: 1,
        }}
      >
        <path
          d="m299.226 529.637-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
          style={{
            fill: "#fec125",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunderSun_svg__b)"
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
      style={{
        fill: "#fec125",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#fec125",
          fillOpacity: 1,
        }}
      >
        <path
          d="M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
          style={{
            fill: "#fec125",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunderSun_svg__c)"
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664S5.889 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.005-.253.005-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(928.4 228.31)"
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunderSun_svg__d)"
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
      style={{
        fill: "#d5eaf8",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#d5eaf8",
          fillOpacity: 1,
        }}
      >
        <path
          d="M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
          style={{
            fill: "#d5eaf8",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunderSun_svg__e)"
      transform="matrix(1.33333 0 0 -1.33333 -1173.14 369.763)"
      style={{
        fill: "#00b5f1",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#00b5f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m895.908 219.964-2.887-5a2 2 0 0 1 .732-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2 2 0 0 1-.733 2.732 1.996 1.996 0 0 1-2.732-.732"
          style={{
            fill: "#00b5f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunderSun_svg__f)"
      transform="matrix(1.33333 0 0 -1.33333 -1177.14 369.763)"
      style={{
        fill: "#00b5f1",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#00b5f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m909.52 219.964-2.887-5a2 2 0 0 1 .733-2.732 2.001 2.001 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
          style={{
            fill: "#00b5f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#RainThunderSun_svg__g)"
      transform="matrix(1.33333 0 0 -1.33333 -1165.14 369.763)"
      style={{
        fill: "#00b5f1",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#00b5f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m924.132 219.964-2.887-5a2 2 0 0 1 .732-2.732 2 2 0 0 1 2.732.732l2.888 5a2 2 0 0 1-1.733 3.001 1.996 1.996 0 0 1-1.732-1.001"
          style={{
            fill: "#00b5f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 -384 1257.85)"
      d="M288-943.388h72v72h-72z"
    />
  </svg>
);

export default SvgRainThunderSun;
